import { unhandledRequest } from 'api/request';

import { JourneyListEnvelope, JourneyListRow } from '../components/types';

// ---- Types ----

export type JobJourney = JourneyListRow;

export type JobJourneysResponse = JourneyListEnvelope<JobJourney>;

export type SetJobJourneyEnabledInput = {
  jobId: number;
  journeyId: string;
  isEnabled: boolean | null;
};

export type SetJobJourneyEnabledResponse = {
  journeyId: string;
  isEnabled: boolean | null;
};

// ---- API functions ----

/**
 * GET jobs/<job_id>/journeys/
 *
 * Returns globally-enabled journeys with per-job resolved enabled state.
 * A journey with no per-job override (null-inherit) is returned with isEnabled=true.
 */
export async function getJobJourneys(jobId: number, search: string): Promise<JobJourneysResponse> {
  const response = await unhandledRequest.get<JobJourneysResponse>({
    url: `/integrations/journeys/jobs/${jobId}/journeys/`,
    params: { search },
  });
  return response.data;
}

/**
 * PUT jobs/<job_id>/journeys/<journey_id>/enabled/
 *
 * Sets the per-job availability of a journey.
 * isEnabled: true/false = explicit; null = revert to inherit (global setting).
 */
export async function setJobJourneyEnabled(
  input: SetJobJourneyEnabledInput
): Promise<SetJobJourneyEnabledResponse> {
  const response = await unhandledRequest.put<SetJobJourneyEnabledResponse>({
    url: `/integrations/journeys/jobs/${input.jobId}/journeys/${input.journeyId}/enabled/`,
    data: { isEnabled: input.isEnabled },
  });
  return response.data;
}
